module.exports = __webpack_public_path__ + "img/about-412.0f1bc22b.webp";